import type { ComponentType } from 'react'
import type { AdminPermissions, AdminSectionGroup, AdminSectionId, AdminSectionProps } from './types'
import { CatalogSection } from './CatalogSection'
import { DocumentsSection } from './DocumentsSection'
import { EquipmentSection } from './EquipmentSection'
import { IntegrationsSection } from './IntegrationsSection'
import { MonitoringSection } from './MonitoringSection'
import { OrganizationSection } from './OrganizationSection'
import { OverviewSection } from './OverviewSection'
import { ReportsSection } from './ReportsSection'
import { RolesSection } from './RolesSection'
import { SalesSection } from './SalesSection'
import { StaffSection } from './StaffSection'

/** Пункт реестра разделов админки. */
export interface AdminSectionEntry {
  id: AdminSectionId
  label: string
  /** Группа меню: работа / магазин / настройки. */
  group: AdminSectionGroup
  /** Какое право требуется для доступа (undefined — доступно всем). */
  permission?: keyof AdminPermissions
  Component: ComponentType<AdminSectionProps>
}

/** Порядок и подписи разделов админки (9 пунктов). */
export const ADMIN_SECTIONS: AdminSectionEntry[] = [
  { id: 'overview', label: 'Обзор', group: 'work', Component: OverviewSection },
  { id: 'sales', label: 'Продажи', group: 'work', Component: SalesSection },
  { id: 'reports', label: 'Отчёты', group: 'work', Component: ReportsSection },
  { id: 'catalog', label: 'Каталог', group: 'shop', Component: CatalogSection },
  { id: 'equipment', label: 'Оборудование', group: 'shop', Component: EquipmentSection },
  {
    id: 'documents',
    label: 'Документы',
    group: 'shop',
    permission: 'canCorrect',
    Component: DocumentsSection
  },
  { id: 'staff', label: 'Сотрудники', group: 'settings', permission: 'canManageCloud', Component: StaffSection },
  { id: 'roles', label: 'Роли', group: 'settings', permission: 'canManageCloud', Component: RolesSection },
  {
    id: 'organization',
    label: 'Организация',
    group: 'settings',
    permission: 'canManageCloud',
    Component: OrganizationSection
  },
  { id: 'integrations', label: 'Интеграции', group: 'settings', permission: 'canManageCloud', Component: IntegrationsSection },
  { id: 'monitoring', label: 'Монитор', group: 'settings', permission: 'canManageCloud', Component: MonitoringSection }
]

/** Доступен ли раздел при данных правах. */
export function isSectionAllowed(section: AdminSectionEntry, perms: AdminPermissions): boolean {
  return !section.permission || perms[section.permission]
}
